var _style, _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSmileyHappy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  id: "smiley_happy_svg__Plus",
  x: 0,
  y: 0,
  viewBox: "0 0 24 24"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".smiley_happy_svg__st1{fill:$colour-neutral-grey-900}")), /*#__PURE__*/React.createElement("path", {
  d: "M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0",
  style: {
    fill: "#ffdb00"
  }
}), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8.3,
  cy: 9.3,
  r: 1.3,
  className: "smiley_happy_svg__st1"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 15.7,
  cy: 9.3,
  r: 1.3,
  className: "smiley_happy_svg__st1"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 18.6c2.5 0 4.9-1.3 6.3-3.4l-1.1-.7c-1.3 2-3.6 3-5.9 2.8-1.8-.2-3.5-1.2-4.5-2.8l-1.1.7c1.2 1.9 3.2 3.1 5.4 3.4z",
  className: "smiley_happy_svg__st1"
})));
export { SvgSmileyHappy as ReactComponent };
export default __webpack_public_path__ + "smiley_happy.svg";